import { useBanners } from '../../context/BannerContext';

/**
 * Renders all active app-wide banners in priority order.
 * Placed inside AppShell's <main>, before <Outlet />.
 */
export function BannerStack() {
  const { banners } = useBanners();
  if (banners.length === 0) return null;
  return (
    <>
      {banners.map(b => (
        <div key={b.id}>{b.content}</div>
      ))}
    </>
  );
}
